// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".center[data-v-0a7903d6] {\n  text-align: center;\n}\n.text-con[data-v-0a7903d6] {\n  margin-left: 40px;\n  margin-top: 30px;\n  margin-right: 40px;\n}\n.form-control[data-v-0a7903d6] {\n  width: 100%;\n}\n.w80[data-v-0a7903d6] {\n  width: 80px;\n  margin-right: 12px;\n}", ""]);
// Exports
module.exports = exports;
